const platformNavigation = [
  {
    name: "Platform dashboard",
    href: "/platform/dashboard",
    navId: "nav.platformDashboard",
    iconKey: "Dashboard",
    permission: "platform.dashboard",
  },
  {
    name: "System customers",
    href: "/platform/customers",
    navId: "nav.systemCustomers",
    iconKey: "Business",
    permission: "platform.customers.read",
  },
  {
    name: "Platform roles",
    href: "/platform/roles",
    navId: "nav.platformRoles",
    iconKey: "Shield",
    permission: "platform.roles",
  },
  {
    name: "Platform operators",
    href: "/platform/operators",
    navId: "nav.platformOperators",
    iconKey: "People",
    permission: "platform.operators",
  },
];

export { platformNavigation };
